/**
 * The details behind a partial Apply.
 * For Media Devoted | Created By Ciro Autiero
 *
 * Opens by itself on a partial rather than hanging off the toast: ToastProvider
 * has no action button, and a tracker write that only half landed is precisely
 * the detail that must not scroll away unread.
 */

import { FC } from 'react';
import type { FlowOptimizerApplyReport } from '@trafficpulse/shared';

import { ConfirmDialog } from '@/components/ui';

import ApplyReportList from './ApplyReportList';

export interface ApplyReportDialogProps {
  report: FlowOptimizerApplyReport | null;
  onClose: () => void;
}

export const ApplyReportDialog: FC<ApplyReportDialogProps> = ({
  report,
  onClose,
}) => (
  <ConfirmDialog
    open={report !== null}
    title="Applied — with some elements skipped"
    widthClass="max-w-lg"
    description={report ? <ApplyReportList report={report} /> : null}
    confirmLabel="Close"
    hideCancel
    onConfirm={onClose}
    onCancel={onClose}
  />
);

export default ApplyReportDialog;
